import { render, staticRenderFns } from "./BotSelectorDialog.vue?vue&type=template&id=488dc5d2&scoped=true&"
import script from "./BotSelectorDialog.vue?vue&type=script&lang=js&"
export * from "./BotSelectorDialog.vue?vue&type=script&lang=js&"
import style0 from "./BotSelectorDialog.vue?vue&type=style&index=0&id=488dc5d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488dc5d2",
  null
  
)

export default component.exports